var React = require('react');

function TriangleHeaderBgDesktop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M149.848 76.7324L91.5967 8.86404M149.848 76.7324L81.5402 69.2943M149.848 76.7324L19.7279 91.9474M91.5967 8.86404L81.5402 69.2943M91.5967 8.86404L19.7279 91.9474M81.5402 69.2943L19.7279 91.9474","stroke":"#543D6B"}));
}

TriangleHeaderBgDesktop.defaultProps = {"width":"151","height":"140","viewBox":"0 0 151 140","fill":"none"};

module.exports = TriangleHeaderBgDesktop;

TriangleHeaderBgDesktop.default = TriangleHeaderBgDesktop;
